import FetchFactory from "vuex-fetch-factory";
import { StateInterface } from "./state";
import { ProjectRaw, ProjectModel } from "../models";
import {
  getProjectsForCurrentUser,
  getSubscriptionsForCurrentUser
} from "../api";
import { setProjectsHandle, setSubscriptionsHandle } from "./mutations";

const factory = new FetchFactory<StateInterface, {}>();

export default {
  fetchProjects: factory.createBulkFetcher<{}, ProjectRaw, ProjectModel>(
    true,
    setProjectsHandle,
    getProjectsForCurrentUser,
    (): ProjectModel => new ProjectModel()
  ),
  fetchSubscriptions: factory.createBulkFetcher<{}, ProjectRaw, ProjectModel>(
    true,
    setSubscriptionsHandle,
    getSubscriptionsForCurrentUser,
    (): ProjectModel => new ProjectModel()
  )
};
